export default [
  {
    dataField: 'NIT',
    style: { width: '87px' },
    text: 'NIT',
    formater: true,
  },
  {
    dataField: 'Razon_social_proveedor',
    // style: { width: '131px' },
    text: 'Razón social de prestador o proveedor',
    formater: true,
  },
  {
    dataField: 'Sede_atencion',
    style: { width: '131px' },
    text: 'Sede de atención',
    formater: true,
  },

  {
    dataField: 'Direccion_sede_atencion',
    style: { width: '195px' },
    text: 'Dirección sede de atención',
    formater: true,
  },

  {
    dataField: 'Depto_sede_atencion',
    // style: { width: '131px' },
    text: 'Departamento sede de atención',
    formater: true,
  },
  {
    dataField: 'Mpio_sede_atencion',
    // style: { width: '131px' },
    text: 'Municipio sede de atención',
    formater: true,
  },
  {
    dataField: 'Canal',
    // style: { width: '131px' },
    text: 'Canal',
    formater: true,
  },
];
